import { IconArrowLeft, IconCompass, IconHome } from "@tabler/icons-react";
import { Link, useNavigate, useLocation } from "react-router-dom";

import { AppRoutes } from "../../../common/routes/app_routes";
import { Button } from "../../common/button";
import { IconPill } from "../../common/icon-pill";
import { Heading, Text } from "../../common/typography";

export function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const handleGoBack = () => {
    if (location.key !== "default") {
      navigate(-1);
    } else {
      navigate(AppRoutes.INDEX);
    }
  };

  return (
    <div className="flex min-h-[70vh] w-full items-center justify-center px-6 py-16">
      <div className="flex w-full max-w-xl flex-col items-center text-center">
        <IconPill size={56} tone="gradient" shape="circle" className="mb-6">
          <IconCompass size={28} />
        </IconPill>

        <Heading variant="h1" tone="dark">
          404
        </Heading>

        <Heading variant="h2" tone="dark" className="mt-2">
          We can't find that page
        </Heading>

        <Text variant="bodyLg" tone="muted" className="mt-3 max-w-md">
          The page you're looking for may have been moved, renamed, or no longer
          exists. Let's get you back on track.
        </Text>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <Button
            variant="secondary"
            leftIcon={<IconArrowLeft size={18} />}
            onClick={handleGoBack}
          >
            Go back
          </Button>
          <Link to={AppRoutes.INDEX}>
            <Button variant="primary" leftIcon={<IconHome size={18} />}>
              Back to home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
